import { render, staticRenderFns } from "./SensitiveContentGate.vue?vue&type=template&id=5f500101&"
import script from "./SensitiveContentGate.vue?vue&type=script&lang=ts&"
export * from "./SensitiveContentGate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports